import siteType from "../configs/siteType"

/* eslint-disable */
let register = {}
if (siteType.GetSiteType() == siteType.SITE_TYPE_NUTS) {
  register = {
    "LAB_CLUB_INVITE_H5_WELCOME": "ยินดีต้อนรับสู่ {club}",
    "LAB_CLUB_INVITE_H5_WELCOME_LONG": "เมื่อลงทะเบียนแล้วคุณจะเข้าร่วมคลับนี้",
    "LAB_REGISTER_USERNAME": "ชื่อผู้ใช้",
    "LAB_AUTH_EMAIL": "อีเมล",
    "LAB_ACCOUNT_EMAIL_FORM_WRONG": "รูปแบบอีเมลไม่ถูกต้อง",
    "LAB_ACCOUNT_ALREADY_REGISTERED": "* เคยมีการใช้อีเมลนี้ลงทะเบียนแล้ว",
    "LAB_KYC_INVALID_EMAIL": "ไม่สามารถใช้ที่อยู่อีเมลนี้ได้",
    "LAB_ACCOUNT_FORMAT_TIP": "*ชื่อผู้ใช้จะต้องเป็นตัวอักษัภาษาอังกฤษหรือตัวเลข 4-20 ตัวอักษร",
    "LAB_ACCOUNT_FORMAT_TIP2": "*ชื่อผู้ใช้จะต้องไม่มีช่องว่างหรือตัวอักษรพิเศษ",
    "LAB_PASSWORD": "รหัสผ่าน",
    "LAB_REGISTER_PASSWORD_TIP2": "รหัสผ่านต้องประกอบด้วย 6-16 ตัวอักษรและมีพยัญชนะกับตัวเลขอย่างน้อยอย่างละหนึ่งตัว",
    "LAB_REGISTER_PASSWORD_TIP3": "ไม่สามารถใช้ {word} ในรหัสผ่านได้",
    "LAB_REGISTER_PASSWORD_TIP4": "ไม่สามารถเว้นวรรคในรหัสผ่านได้",
    "LAB_CLUB_INVITE_H5_Verifiy": "รหัสยืนยัน",
    "LAB_VERIFICATION_CODE_ERROR": "รหัสยืนยันผิด",
    "LAB_REGISTER_RIGHT_NOW": "ลงทะเบียน",
    "LAB_CLUB_INVITE_H5_Download_1": "มีบัญชีอยู่แล้ว?",
    "LAB_CLUB_INVITE_H5_Download_2": "ดาวน์โหลดเลย",
    "LAB_CLUB_INVITE_H5_Success": "การลงทะเบียนสำเร็จ!",
    "LAB_CLUB_CHECK_TEMS1": "คลิกที่นี่เพื่อแสดงว่าคุณอายุเกิน 18 ปี และได้อ่านและยอมรับ: ",
    "LAB_CLUB_CHECK_TEMS2": "เงื่อนไขการให้บริการ",
    "LAB_CLUB_CHECK_TEMS3": "และ",
    "LAB_CLUB_CHECK_TEMS4": "นโยบายความเป็นส่วนตัวแล้ว",
    "LAB_CLUB_CHECK_TIPS": "โปรดแสดงการยอมรับของคุณกับเงื่อนไขการให้บริการและนโยบายความเป็นส่วนตัว",
    "LAB_REGISTER_MUCH": "ห้ามลงทะเบียนหลายครั้ง!",
    "LAB_CLUB_INVITE_CODE_ERROR": "รหัสไม่ถูกต้อง",
    "LAB_HISTORY_SHARE_ERROR": "คำขอล้มเหลว โปรดลองอีกครั้งในภายหลัง",
    "LAB_H5_Marketing_Programme": "เงื่อนไขและข้อตกลงของโปรแกรมการตลาดที่เกี่ยวข้อง",
    "LAB_H5_CHECK_TIPS": "คลิกที่นี่เพื่อยืนยันว่าคุณมีอายุเกิน 18 ปีและคุณได้อ่านและยอมรับ: {link1}, {link2}และ{link3}",
    "LAB_PLAY_NOW": "เล่นเลย!",
    "LAB_TITLE_1": "รับประกันคืนเงิน",
    "LAB_CONTENT_1": "สามารถรับเงินเฉลี่ยคืนแบบทันทีสูงสุดถึง 50% หลังจากเล่นจบแต่ละเกม!",
    "LAB_TITLE_2": "ผู้เล่นทั่วโลก",
    "LAB_CONTENT_2": "เกมที่น่าตื่นเต้นต่างๆ เปิดให้เล่น 24 ชั่วโมงทุกวัน!",
    "LAB_TITLE_3": "โบนัสไม่หยุดหย่อน",
    "LAB_CONTENT_3": "เล่นเพื่อลุ้นรับรางวัลใหญ่จากลีดเดอร์บอร์ด พายุเงิน ภารกิจ และแจ็คพ็อตของเรา",
    "LAB_TITLE_4": "คุ้มครองยอดเงิน",
    "LAB_CONTENT_4": "ได้รับใบอนุญาตโป๊กเกอร์ออนไลน์ขั้นที่ 1 ที่ออกโดยคณะกรรมการควบคุมการเดิมพันของไอล์ออฟแมน",
    "LAB_BE_MORE": "เป็นได้มากกว่าผู้เล่นที่ NUTS POKER!",
    "LAB_PLAY_BEST": "เล่นเกมโป๊กเกอร์ที่ดีที่สุดตอนนี้เลย!",
    "LAB_SERVICE": "ผลิตภัณฑ์และบริการที่เสนอโดย NUTS POKER (ทางเว็บไซต์ และแอปบนมือถือและแท็บเล็ต) เรียกรวมว่า ‘บริการ’",
    "LAB_ENJOY": "เพลิดเพลินกับ\nโป๊กเกอร์รูปแบบต่างๆ",
    "LAB_MORE": "NLH, PLO, OFC และอื่นๆ อีกเพียบ!",
    "LAB_PLAY_GAME": "เล่นกับเราเพื่อสำรวจเกมโป๊กเกอร์อันหลากหลาย!",
    "LAB_MODE": "เรามีเกมโป๊กเกอร์ให้เล่นจำนวนมากตั้งแต่คลาสสิกไปจนเกมฮิตตามกระแส ได้แก่ No-Limit Texas Hold'em, PLO, 6+ และ OFC ซึ่งมีรูปแบบย่อยที่น่าตื่นเต้นต่างๆ อย่างเช่นโหมด Progressive, โหมด Ultimate และโหมดโจ๊กเกอร์",
    "LAB_TODAY": "ร่วมสนุกกับเราวันนี้!",
    "LAB_ACTION": "เล่นสามโต๊ะ\nสนุกกำลังสาม",
    "LAB_MASTER": "ขัดเกลาฝีมือเพื่อเป็นเซียนหลายโต๊ะ",
    "LAB_SAME_TIME": "ฟีเจอร์หลายโต๊ะทำให้คุณสามารถเล่นได้\nพร้อมกันในสามโต๊ะบนอุปกรณ์เดียว!",
    "LAB_SWIPE": "เพื่อประสบการณ์การเล่นที่ดีที่สุด โต๊ะจะได้รับการทำเครื่องหมายโดยอัตโนมัติ\nเมื่อถึงเทิร์นของคุณ และย้ายไปยังตำแหน่งที่คุณต้องออกคำสั่งได้โดยการปัดครั้งเดียว",
    "LAB_SAFE": "ประสบการณ์เกม\nที่ปลอดภัยและยุติธรรม",
    "LAB_ASSEM": "ทีมต่อต้านการโกงโดยเฉพาะ!",
    "LAB_RULES": "NUTS POKER ไม่ประนีประนอมกับการเล่นที่ไม่เป็นธรรม\nและจะระงับบัญชีที่ตรวจพบว่าละเมิดกติกาเป็นการถาวร",
    "LAB_TABLES": "เรามีกลไกต่อต้านการโกงเพื่อรับรองการตรวจจับพฤติกรรมที่ไม่เหมาะสม\nพร้อมทีมผู้เชี่ยวชาญคอยสังเกตการณ์โต๊ะต่างๆ",
    "LAB_EVERY_DAY": "สนุกกับเกมที่สนุกและยุติธรรมได้ทุกวันที่ NUTS POKER!",
    "LAB_ACCESS": "การเข้าถึงบริการอาจขัดต่อกฎหมายของผู้อยู่อาศัยและผู้พำนักใน{link} การให้บริการ ณ ที่นี้ไม่ได้เป็นการเสนอ ชักนำ หรือเชื้อเชิญโดย NUTS POKER ให้ทำการใช้ สมัคร เดิมพัน เล่นเกมหรือใช้บริการอื่นใดในเขตปกครองที่กิจกรรมดังกล่าวไม่ได้รับอนุญาตตามกฎหมาย โดยเฉพาะผู้อยู่อาศัยหรือผู้พำนักในสหรัฐอเมริกาจะต้องไม่ใช้บริการใดๆ",
    "LAB_BRAND": "NUTS POKER เป็นแบรนด์และชื่อธุรกิจจดทะเบียนของ Aceking IOM Limited ที่อยู่จดทะเบียน 49 Victoria Street, Douglas, Isle of Man, IM1 2LD",
    "LAB_GAMEBLING": "ได้รับอนุญาตและควบคุมดูแลโดยคณะกรรมการควบคุมการเดิมพันของไอล์ออฟแมนภายใต้ข้อกำหนดการเดิมพันออนไลน์",
    "LAB_AGE": "ปี 2001 ตั้งแต่ 24 กรกฎาคม 2019 (ต่ออายุล่าสุด: 24 กรกฎาคม 2019) บุคคลที่มีอายุไม่ถึง 18 ปีไม่ได้รับอนุญาตให้สร้างบัญชีและ/หรือมีส่วนร่วมในการเดิมพัน เงินฝากหรือเงินรางวัลที่ชนะใดๆ กับ NUTS POKER มีความปลอดภัยและสามารถบังคับได้โดยกฎหมายของไอล์ออฟแมน",
    "LAB_FOLLOW": "FOLLOW US",
    "LAB_COUNTRIES": "บางประเทศ",
    "LAB_ABOUT": "เกี่ยวกับเรา",
    "LAB_POLICY": "นโยบายความเป็นส่วนตัวแล้ว",
    "LAB_TERM": "เงื่อนไขการให้บริการ",
    "LAB_COPY": "ลิขสิทธิ์ถูกต้อง© {link}NUTS POKER สงวนสิทธิ์ทั้งหมด",
    "LAB_DOWNLOAD": "ดาวน์โหลด",
    "LAB_VERIFICATION": "การยืนยัน",
    "LAB_PLEASE_TYPE": "โปรดพิมพ์ข้อความในภาพ",
    "LAB_CONFIRM": "ยืนยัน",
    "LAB_SERVICE_CO": "ผลิตภัณฑ์และบริการที่เสนอโดย NUTS POKER Global (ทางเว็บไซต์ และแอปบนมือถือและแท็บเล็ต) เรียกรวมว่า ‘บริการ’",
    "LAB_ACCESS_CO": "การเข้าถึงบริการอาจขัดต่อกฎหมายของผู้อยู่อาศัยและผู้พำนักใน{link} การให้บริการ ณ ที่นี้ไม่ได้เป็นการเสนอ ชักนำ หรือเชื้อเชิญโดย NUTS POKER Global ให้ทำการใช้ สมัคร เดิมพัน เล่นเกมหรือใช้บริการอื่นใดในเขตปกครองที่กิจกรรมดังกล่าวไม่ได้รับอนุญาตตามกฎหมาย โดยเฉพาะผู้อยู่อาศัยหรือผู้พำนักในสหรัฐอเมริกาจะต้องไม่ใช้บริการใดๆ",
    "LAB_GAMEBLING_CO": "เงินฝากหรือเงินรางวัลที่ชนะใดๆ กับ NUTS POKER Global มีความปลอดภัยและสามารถบังคับได้โดยกฎหมายของกือราเซา",
    "LAB_AGE_CO": "บุคคลที่มีอายุไม่ถึง 18 ปีไม่ได้รับอนุญาตให้สร้างบัญชีและ/หรือมีส่วนร่วมในการเดิมพัน",
    "LAB_CLUB_CHECK_TEMS4_CO": "การจัดการข้อมูลส่วนบุคคลและความเป็นส่วนตัว",
    "LAB_PRIVACYPOLICE_CO": "ข้อมูลส่วนบุคคลและความเป็นส่วนตัว",
    "LAB_CONTENT_4_CO": "ได้รับอนุญาตและควบคุมดูแลโดย Curaçao eGaming",
    "LAB_VERIFY_EMAIL": "ยืนยันอีเมลของคุณ",
    "LAB_VERIFY_EMAIL_ADDRESS": "เราได้ส่งอีเมลไปยัง {email address}",
    "LAB_VERIFY_TIPS": "เพื่อทำการยืนยันที่อยู่อีเมลและเปิดใช้บัญชีของคุณ โปรดคลิกลิงก์ยืนยันที่ส่งให้คุณทางอีเมล หากไม่พบ อีเมลอาจอยู่ในถังขยะ",
    "LAB_VERIFY_RESEND": "ส่งอีเมลซ้ำ",
    "LAB_VERIFY_CODE_TIPS": "โปรดพิมพ์ข้อความในภาพเพื่อยืนยันว่าคุณเป็นมนุษย์",
    "LAB_EMAIL_VERIFIED": "ยืนยันอีเมลแล้ว",
    "LAB_EMAIL_DOWNLOAD_TIPS": "สร้างบัญชีของคุณสำเร็จแล้ว คลิกที่ปุ่มด้านล่างเพื่อดาวน์โหลด NUTS POKER แล้วเริ่มเล่นเกม",
    "LAB_EMAIL_DOWNLOAD": "ดาวน์โหลด NUTS POKER",
    "LAB_EMAIL_VERIFY_ACCOUNT": "ยืนยันบัญชี NUTS POKER ของคุณ",
    "LAB_EMAIL_EXPIRED_1": "โอ๊ะโอ ลิงก์หมดอายุแล้ว",
    "LAB_EMAIL_EXPIRED_2": "โปรดไปที่หน้าลงทะเบียนเพื่อขอลิงก์ยืนยันใหม่",
    "LAB_VERIFY_PROTECT": "ดูวิธีที่เราปกป้องข้อมูลส่วนตัวของคุณ",
    "LAB_EMAIL_FAILED": "ไม่สำเร็จ โปรดลองอีกครั้งในภายหลัง"
  }
} else {
  register = {
    "LAB_CLUB_INVITE_H5_WELCOME": "ยินดีต้อนรับสู่ {club}",
    "LAB_CLUB_INVITE_H5_WELCOME_LONG": "เมื่อลงทะเบียนแล้วคุณจะเข้าร่วมคลับนี้",
    "LAB_REGISTER_USERNAME": "ชื่อผู้ใช้",
    "LAB_AUTH_EMAIL": "อีเมล",
    "LAB_ACCOUNT_EMAIL_FORM_WRONG": "รูปแบบอีเมลไม่ถูกต้อง",
    "LAB_ACCOUNT_ALREADY_REGISTERED": "* เคยมีการใช้อีเมลนี้ลงทะเบียนแล้ว",
    "LAB_KYC_INVALID_EMAIL": "ไม่สามารถใช้ที่อยู่อีเมลนี้ได้",
    "LAB_ACCOUNT_FORMAT_TIP": "*ชื่อผู้ใช้จะต้องเป็นตัวอักษัภาษาอังกฤษหรือตัวเลข 4-20 ตัวอักษร",
    "LAB_ACCOUNT_FORMAT_TIP2": "*ชื่อผู้ใช้จะต้องไม่มีช่องว่างหรือตัวอักษรพิเศษ",
    "LAB_PASSWORD": "รหัสผ่าน",
    "LAB_REGISTER_PASSWORD_TIP2": "รหัสผ่านต้องประกอบด้วย 6-16 ตัวอักษรและมีพยัญชนะกับตัวเลขอย่างน้อยอย่างละหนึ่งตัว",
    "LAB_REGISTER_PASSWORD_TIP3": "ไม่สามารถใช้ {word} ในรหัสผ่านได้",
    "LAB_REGISTER_PASSWORD_TIP4": "ไม่สามารถเว้นวรรคในรหัสผ่านได้",
    "LAB_CLUB_INVITE_H5_Verifiy": "รหัสยืนยัน",
    "LAB_VERIFICATION_CODE_ERROR": "รหัสยืนยันผิด",
    "LAB_REGISTER_RIGHT_NOW": "ลงทะเบียน",
    "LAB_CLUB_INVITE_H5_Download_1": "มีบัญชีอยู่แล้ว?",
    "LAB_CLUB_INVITE_H5_Download_2": "ดาวน์โหลดเลย",
    "LAB_CLUB_INVITE_H5_Success": "การลงทะเบียนสำเร็จ!",
    "LAB_CLUB_CHECK_TEMS1": "คลิกที่นี่เพื่อแสดงว่าคุณอายุเกิน 18 ปี และได้อ่านและยอมรับ: ",
    "LAB_CLUB_CHECK_TEMS2": "เงื่อนไขการให้บริการ",
    "LAB_CLUB_CHECK_TEMS3": "และ",
    "LAB_CLUB_CHECK_TEMS4": "นโยบายความเป็นส่วนตัวแล้ว",
    "LAB_CLUB_CHECK_TIPS": "โปรดแสดงการยอมรับของคุณกับเงื่อนไขการให้บริการและนโยบายความเป็นส่วนตัว",
    "LAB_REGISTER_MUCH": "ห้ามลงทะเบียนหลายครั้ง!",
    "LAB_CLUB_INVITE_CODE_ERROR": "รหัสไม่ถูกต้อง",
    "LAB_HISTORY_SHARE_ERROR": "คำขอล้มเหลว โปรดลองอีกครั้งในภายหลัง",
    "LAB_H5_Marketing_Programme": "เงื่อนไขและข้อตกลงของโปรแกรมการตลาดที่เกี่ยวข้อง",
    "LAB_H5_CHECK_TIPS": "คลิกที่นี่เพื่อยืนยันว่าคุณมีอายุเกิน 18 ปีและคุณได้อ่านและยอมรับ: {link1}, {link2}และ{link3}",
    "LAB_PLAY_NOW": "เล่นเลย!",
    "LAB_TITLE_1": "รับประกันคืนเงิน",
    "LAB_CONTENT_1": "สามารถรับเงินเฉลี่ยคืนแบบทันทีสูงสุดถึง 50% หลังจากเล่นจบแต่ละเกม!",
    "LAB_TITLE_2": "ผู้เล่นทั่วโลก",
    "LAB_CONTENT_2": "เกมที่น่าตื่นเต้นต่างๆ เปิดให้เล่น 24 ชั่วโมงทุกวัน!",
    "LAB_TITLE_3": "โบนัสไม่หยุดหย่อน",
    "LAB_CONTENT_3": "เล่นเพื่อลุ้นรับรางวัลใหญ่จากลีดเดอร์บอร์ด พายุเงิน ภารกิจ และแจ็คพ็อตของเรา",
    "LAB_TITLE_4": "คุ้มครองยอดเงิน",
    "LAB_CONTENT_4": "ได้รับใบอนุญาตโป๊กเกอร์ออนไลน์ขั้นที่ 1 ที่ออกโดยคณะกรรมการควบคุมการเดิมพันของไอล์ออฟแมน",
    "LAB_BE_MORE": "เป็นได้มากกว่าผู้เล่นที่ KKPoker!",
    "LAB_PLAY_BEST": "เล่นเกมโป๊กเกอร์ที่ดีที่สุดตอนนี้เลย!",
    "LAB_SERVICE": "ผลิตภัณฑ์และบริการที่เสนอโดย KKPoker (ทางเว็บไซต์ และแอปบนมือถือและแท็บเล็ต) เรียกรวมว่า ‘บริการ’",
    "LAB_ENJOY": "เพลิดเพลินกับ\r\nโป๊กเกอร์รูปแบบต่างๆ",
    "LAB_MORE": "NLH, PLO, OFC และอื่นๆ อีกเพียบ!",
    "LAB_PLAY_GAME": "เล่นกับเราเพื่อสำรวจเกมโป๊กเกอร์อันหลากหลาย!",
    "LAB_MODE": "เรามีเกมโป๊กเกอร์ให้เล่นจำนวนมากตั้งแต่คลาสสิกไปจนเกมฮิตตามกระแส ได้แก่ No-Limit Texas Hold'em, PLO, 6+ และ OFC ซึ่งมีรูปแบบย่อยที่น่าตื่นเต้นต่างๆ อย่างเช่นโหมด Progressive, โหมด Ultimate และโหมดโจ๊กเกอร์",
    "LAB_TODAY": "ร่วมสนุกกับเราวันนี้!",
    "LAB_ACTION": "เล่นสามโต๊ะ\r\nสนุกกำลังสาม",
    "LAB_MASTER": "ขัดเกลาฝีมือเพื่อเป็นเซียนหลายโต๊ะ",
    "LAB_SAME_TIME": "ฟีเจอร์หลายโต๊ะทำให้คุณสามารถเล่นได้\r\nพร้อมกันในสามโต๊ะบนอุปกรณ์เดียว!",
    "LAB_SWIPE": "เพื่อประสบการณ์การเล่นที่ดีที่สุด โต๊ะจะได้รับการทำเครื่องหมายโดยอัตโนมัติ\r\nเมื่อถึงเทิร์นของคุณ และย้ายไปยังตำแหน่งที่คุณต้องออกคำสั่งได้โดยการปัดครั้งเดียว",
    "LAB_SAFE": "ประสบการณ์เกม\r\nที่ปลอดภัยและยุติธรรม",
    "LAB_ASSEM": "ทีมต่อต้านการโกงโดยเฉพาะ!",
    "LAB_RULES": "KKPoker ไม่ประนีประนอมกับการเล่นที่ไม่เป็นธรรม\r\nและจะระงับบัญชีที่ตรวจพบว่าละเมิดกติกาเป็นการถาวร",
    "LAB_TABLES": "เรามีกลไกต่อต้านการโกงเพื่อรับรองการตรวจจับพฤติกรรมที่ไม่เหมาะสม\r\nพร้อมทีมผู้เชี่ยวชาญคอยสังเกตการณ์โต๊ะต่างๆ",
    "LAB_EVERY_DAY": "สนุกกับเกมที่สนุกและยุติธรรมได้ทุกวันที่ KKPoker!",
    "LAB_ACCESS": "การเข้าถึงบริการอาจขัดต่อกฎหมายของผู้อยู่อาศัยและผู้พำนักใน{link} การให้บริการ ณ ที่นี้ไม่ได้เป็นการเสนอ ชักนำ หรือเชื้อเชิญโดย KKPoker ให้ทำการใช้ สมัคร เดิมพัน เล่นเกมหรือใช้บริการอื่นใดในเขตปกครองที่กิจกรรมดังกล่าวไม่ได้รับอนุญาตตามกฎหมาย โดยเฉพาะผู้อยู่อาศัยหรือผู้พำนักในสหรัฐอเมริกาจะต้องไม่ใช้บริการใดๆ",
    "LAB_BRAND": "KKPoker เป็นแบรนด์และชื่อธุรกิจจดทะเบียนของ Aceking IOM Limited ที่อยู่จดทะเบียน 49 Victoria Street, Douglas, Isle of Man, IM1 2LD",
    "LAB_GAMEBLING": "ได้รับอนุญาตและควบคุมดูแลโดยคณะกรรมการควบคุมการเดิมพันของไอล์ออฟแมนภายใต้ข้อกำหนดการเดิมพันออนไลน์",
    "LAB_AGE": "ปี 2001 ตั้งแต่ 24 กรกฎาคม 2019 (ต่ออายุล่าสุด: 24 กรกฎาคม 2019) บุคคลที่มีอายุไม่ถึง 18 ปีไม่ได้รับอนุญาตให้สร้างบัญชีและ/หรือมีส่วนร่วมในการเดิมพัน เงินฝากหรือเงินรางวัลที่ชนะใดๆ กับ KKPoker มีความปลอดภัยและสามารถบังคับได้โดยกฎหมายของไอล์ออฟแมน",
    "LAB_FOLLOW": "FOLLOW US",
    "LAB_COUNTRIES": "บางประเทศ",
    "LAB_ABOUT": "เกี่ยวกับเรา",
    "LAB_POLICY": "นโยบายความเป็นส่วนตัวแล้ว",
    "LAB_TERM": "เงื่อนไขการให้บริการ",
    "LAB_COPY": "ลิขสิทธิ์ถูกต้อง© {link}KKPoker สงวนสิทธิ์ทั้งหมด",
    "LAB_DOWNLOAD": "ดาวน์โหลด",
    "LAB_VERIFICATION": "การยืนยัน",
    "LAB_PLEASE_TYPE": "โปรดพิมพ์ข้อความในภาพ",
    "LAB_CONFIRM": "ยืนยัน",
    "LAB_SERVICE_CO": "ผลิตภัณฑ์และบริการที่เสนอโดย KKPoker Global (ทางเว็บไซต์ และแอปบนมือถือและแท็บเล็ต) เรียกรวมว่า ‘บริการ’",
    "LAB_ACCESS_CO": "การเข้าถึงบริการอาจขัดต่อกฎหมายของผู้อยู่อาศัยและผู้พำนักใน{link} การให้บริการ ณ ที่นี้ไม่ได้เป็นการเสนอ ชักนำ หรือเชื้อเชิญโดย KKPoker Global ให้ทำการใช้ สมัคร เดิมพัน เล่นเกมหรือใช้บริการอื่นใดในเขตปกครองที่กิจกรรมดังกล่าวไม่ได้รับอนุญาตตามกฎหมาย โดยเฉพาะผู้อยู่อาศัยหรือผู้พำนักในสหรัฐอเมริกาจะต้องไม่ใช้บริการใดๆ",
    "LAB_BRAND_CO": "kkpoker.co ดำเนินการโดย Violet Fortune Tech Limited N.V. ซึ่งจดทะเบียนหมายเลข 158923 ที่ Perseusweg 27A, Willemstad, Curaçao เว็บไซต์นี้ได้รับใบอนุญาตและกำกับดูแลโดย Curaçao eGaming (ใบอนุญาตของกือราเซาหมายเลข 1668 JAZ ออกโดย Curaçao eGaming)",
    "LAB_GAMEBLING_CO": "เงินฝากหรือเงินรางวัลที่ชนะใดๆ กับ KKPoker Global มีความปลอดภัยและสามารถบังคับได้โดยกฎหมายของกือราเซา",
    "LAB_AGE_CO": "บุคคลที่มีอายุไม่ถึง 18 ปีไม่ได้รับอนุญาตให้สร้างบัญชีและ/หรือมีส่วนร่วมในการเดิมพัน",
    "LAB_CLUB_CHECK_TEMS4_CO": "การจัดการข้อมูลส่วนบุคคลและความเป็นส่วนตัว",
    "LAB_PRIVACYPOLICE_CO": "ข้อมูลส่วนบุคคลและความเป็นส่วนตัว",
    "LAB_CONTENT_4_CO": "ได้รับอนุญาตและควบคุมดูแลโดย Curaçao eGaming",
    "LAB_VERIFY_EMAIL": "ยืนยันอีเมลของคุณ",
    "LAB_VERIFY_EMAIL_ADDRESS": "เราได้ส่งอีเมลไปยัง {email address}",
    "LAB_VERIFY_TIPS": "เพื่อทำการยืนยันที่อยู่อีเมลและเปิดใช้บัญชีของคุณ โปรดคลิกลิงก์ยืนยันที่ส่งให้คุณทางอีเมล หากไม่พบ อีเมลอาจอยู่ในถังขยะ",
    "LAB_VERIFY_RESEND": "ส่งอีเมลซ้ำ",
    "LAB_VERIFY_CODE_TIPS": "โปรดพิมพ์ข้อความในภาพเพื่อยืนยันว่าคุณเป็นมนุษย์",
    "LAB_EMAIL_VERIFIED": "ยืนยันอีเมลแล้ว",
    "LAB_EMAIL_DOWNLOAD_TIPS": "สร้างบัญชีของคุณสำเร็จแล้ว คลิกที่ปุ่มด้านล่างเพื่อดาวน์โหลด KKPoker แล้วเริ่มเล่นเกม",
    "LAB_EMAIL_DOWNLOAD": "ดาวน์โหลด KKPoker",
    "LAB_EMAIL_VERIFY_ACCOUNT": "ยืนยันบัญชี KKPoker ของคุณ",
    "LAB_EMAIL_EXPIRED_1": "โอ๊ะโอ ลิงก์หมดอายุแล้ว",
    "LAB_EMAIL_EXPIRED_2": "โปรดไปที่หน้าลงทะเบียนเพื่อขอลิงก์ยืนยันใหม่",
    "LAB_VERIFY_PROTECT": "ดูวิธีที่เราปกป้องข้อมูลส่วนตัวของคุณ",
    "LAB_EMAIL_FAILED": "ไม่สำเร็จ โปรดลองอีกครั้งในภายหลัง"
  }
}

export default {
  "register": register
}